<template>
  <div class="painel_desempenho">
    <span class="card-title">Desempenho dos Modais</span>

    <div class="modais-container">
      <div class="card-modais">
        <div class="icon-container">
          <img src="/bus.png" alt="Modal Rodoviário" />
        </div>
        <div class="card-modais-content">
          <p>Modais Rodoviários</p>
          <strong class="large-number">R$500,00</strong><br />
        </div>
      </div>

      <div class="card-modais">
        <div class="icon-container">
          <img src="/voo.png" alt="Modal Aéreo" />
        </div>
        <div class="card-modais-content">
          <p>Modais Aéreos</p>
          <strong class="large-number">R$987,00</strong><br />
        </div>
      </div>
    </div>
    <span class="card-text text-card-right">
      Valores médios do bilhete dos modais durante o período.
    </span>
    <div class="ticket-value-chart-container">
      <div class="ticket-value-chart-header">
        <span class="card-title">Valor da passagem</span>
        <ButtonGroup
          :buttons="buttons"
          :selectedButtonId="selectedButtonId"
          :handleButtonClick="handleButtonClick"
        />
      </div>
      <div v-if="selectedButtonId === 1">
        <div class="chart-custom-header" style="margin-top: 40px">
          <div class="chart-custom-legend-container">
            <CustomLegend color="#9747FF" text="Rodoviário" />
            <CustomLegend color="#279CBA" text="Aeroviário" />
          </div>
          <!-- <div class="chart-custom-buttons-container">
            <CustomChartButton text="Dia" @click="() => handleTicketValueDays('day')" />
            <CustomChartButton text="Semana" @click="() => handleTicketValueDays('week')" />
            <CustomChartButton text="Mês" @click="() => handleTicketValueDays('month')" />
            <CustomChartButton text="Ano" @click="() => handleTicketValueDays('year')" />
          </div> -->
        </div>
        <canvas id="ticket-value-chart" class="ticket-value-chart"></canvas>
      </div>
      <div v-if="selectedButtonId === 2" class="advanced-search-container">
        <CustomMultiSelect
          v-model="selectedModes"
          :options="modes"
          placeholder="Selecione um ou mais modos de transporte"
          :filter="true"
          display="chip"
          @change="handleChange"
        />
        <CustomCalendar
          v-model="selectedInitDate"
          dateFormat="dd/mm/yy"
          label="Data inicial"
          :onDateSelect="handleDateSelect"
        />
        <CustomCalendar
          v-model="selectedEndDate"
          dateFormat="dd/mm/yy"
          label="Data final"
          :onDateSelect="handleDateSelect"
        />
        <Button label="Consultar" @click="handleAdvancedSearch" />
      </div>
    </div>
  </div>
</template>

<script>
import CustomMultiSelect from '@/Shared/CustomMultiSelect.vue'
import CustomLegend from '@/Shared/Charts/CustomLegend'
import ButtonGroup from '@/Shared/ButtonGroup'
import Button from '@/Shared/Button'
import CustomCalendar from '@/Shared/CustomCalendar'
import { Chart, registerables } from 'chart.js'

Chart.register(...registerables)
export default {
  name: 'TransportPerformance',
  components: {
    CustomMultiSelect,
    CustomLegend,
    ButtonGroup,
    CustomCalendar,
    Button,
  },
  data() {
    return {
      selectedButtonId: 1,
      buttons: [
        { id: 1, label: 'Valor médio' },
        { id: 2, label: 'Busca avançada' },
      ],
      selectedInitDate: new Date(),
      selectedEndDate: new Date(),
      selectedModes: [],
      modes: [
        { label: 'Aeroviário', value: 'Aeroviário' },
        { label: 'Rodoviário', value: 'Rodoviário' },
      ],
    }
  },
  watch: {
    selectedButtonId: {
      deep: true,
      immediate: true,
      handler: function (n, o) {
        if (o === 2) {
          setTimeout(() => {
            this.createChart()
          }, 100)
        }
      },
    },
  },
  mounted() {
    this.createChart()
    // this.createVehicleOccupancy()
    // this.createTravelTimeChart()
  },
  methods: {
    handleButtonClick(id) {
      this.selectedButtonId = id
      switch (id) {
        case 1:
          console.log('Valor médio')
          break
        case 2:
          console.log('Busca avançada')
          break
      }
    },

    handleAdvancedSearch(data) {
      this.selectedButtonId = 1
    },

    handleTicketValueDays(id) {
      console.log('handleTicketValueDays')
    },

    handleChange(selectedModes) {
      console.log('Modos de transporte selecionados:', selectedModes)
    },

    handleDateSelect(date) {
      console.log('Data selecionada:', date)
    },
    createChart() {
      const ctx = document.getElementById('ticket-value-chart').getContext('2d')
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho'],
          datasets: [
            {
              label: 'Rodoviário',
              data: [1000, 3400, 1400, 2000, 3000, 4000],
              backgroundColor: '#9747FF',
              borderWidth: 1,
              barThickness: 15,
            },
            {
              label: 'Aeroviário',
              data: [4100, 3000, 4000, 2400, 3400, 1400],
              backgroundColor: '#279CBA',
              borderWidth: 1,
              barThickness: 15,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              enabled: true,
              mode: 'nearest',
              intersect: true,
              callbacks: {
                label: function (context) {
                  return `${context.dataset.data[context.dataIndex]}`
                },
              },
            },
          },
          interaction: {
            mode: 'nearest',
            intersect: true,
          },
        },
      })
    },

    createVehicleOccupancy() {
      const ctx2 = document.getElementById('vehicle-occupancy').getContext('2d')
      new Chart(ctx2, {
        type: 'bar',
        data: {
          labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho'],
          datasets: [
            {
              label: 'Rodoviário',
              data: [100, 20, 30, 40, 100, 20],
              backgroundColor: 'rgba(31, 51, 255, 1)',
              borderWidth: 1,
              barThickness: 5,
            },
            {
              label: 'Aeroviário',
              data: [100, 50, 30, 10, 50, 30],
              backgroundColor: 'rgba(75, 12, 92, 0.5)',
              borderWidth: 1,
              barThickness: 5,
            },
          ],
        },
        options: {
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: { display: false },
            title: { display: false },
            tooltip: {
              enabled: true,
              mode: 'nearest',
              intersect: true,
              callbacks: {
                label: function (context) {
                  return `${context.dataset.data[context.dataIndex]}`
                },
              },
            },
          },
          interaction: {
            mode: 'nearest',
            intersect: true,
          },
        },
      })
    },

    createTravelTimeChart() {
      const ctx = document.getElementById('travel-time-chart').getContext('2d')
      new Chart(ctx, {
        type: 'bar',
        data: {
          labels: ['Rodoviário', 'Marítimo', 'Ferroviário', 'Aeroviário'],
          datasets: [
            {
              label: 'Tempo médio de viagem',
              data: [8, 6, 7, 3],
              backgroundColor: 'rgba(0, 0, 139, 0.8)',
              barThickness: 20,
            },
          ],
        },

        options: {
          indexAxis: 'y',
          responsive: true,
          scales: {
            x: {
              beginAtZero: true,
              ticks: {
                stepSize: 2,
                callback: function (value) {
                  return value + 'hr'
                },
              },
            },
          },
          plugins: {
            legend: {
              display: false,
            },
            title: {
              display: false,
              font: {
                size: 20,
              },
            },
          },
        },
      })
    },
  },
}
</script>

<style src="./styles.css"></style>
